var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"todo-total"},[_c('div',{staticClass:"todo-total-title"},[_vm._t("default")],2),_c('div',{staticClass:"todo-total-value"},[_c('span',[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }